module.exports = __webpack_public_path__ + "static/media/pFTM.17bf246a.svg";